import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Scrollbars } from "react-custom-scrollbars";
const CustomScrollbars = (props) => _jsx(Scrollbars, Object.assign({}, props, { autoHide: false, renderTrackHorizontal: props => _jsx("div", Object.assign({}, props, { style: { display: 'none' }, className: "track-horizontal" })) }));
export default CustomScrollbars;
